/* eslint-disable arrow-body-style */
import { AxiosError, AxiosResponse } from 'axios';
import { ListingModel, PartnerListingModel } from '../store/listings/ListingModels';
import { ResponseStatusModel } from '../store/response-status/ResponseStatusModel';
import SnackbarUtil from '../utils/SnackbarUtil';
import { axiosInstance } from '../utils/axiosConfig';

const LISTINGS_URL = '/api/listings';
const PARTNER_LISTINGS_URL = '/api/listings/partner';

export const getListingsAdapter = (
  lat: string,
  lng: string,
  type: string,
  people: string,
  radius: string,
  objectTypes: string,
  objectCharacteristics: string,
  offerFeatures: string,
  leaseOnly: string,
): Promise<ListingModel[]> => {
  return axiosInstance
    .get(LISTINGS_URL, {
      params: {
        lat: lat,
        lng: lng,
        type: type,
        people: people,
        radius: radius,
        objectTypes: objectTypes,
        objectCharacteristics: objectCharacteristics,
        offerFeatures: offerFeatures,
        leaseOnly: leaseOnly,
      },
    })
    .then((response: AxiosResponse<ListingModel[]>): ListingModel[] => response.data)
    .catch((error: AxiosError): ListingModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const getListingAdapter = (id: string): Promise<ListingModel[]> => {
  return axiosInstance
    .get(`${LISTINGS_URL}/${id}`)
    .then((response: AxiosResponse<ListingModel[]>): ListingModel[] => response.data)
    .catch((error: AxiosError): ListingModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const getPartnerListingsAdapter = (id: string): Promise<PartnerListingModel[]> => {
  return axiosInstance
    .get(`${PARTNER_LISTINGS_URL}/${id}`)
    .then((response: AxiosResponse<PartnerListingModel[]>): PartnerListingModel[] => response.data)
    .catch((error: AxiosError): PartnerListingModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const postListingAdapter = (formData: FormData): Promise<ResponseStatusModel> => {
  return axiosInstance
    .post(LISTINGS_URL, formData)
    .then((response: AxiosResponse<ResponseStatusModel>): ResponseStatusModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    })
    .catch((error: AxiosError): ResponseStatusModel => {
      SnackbarUtil.error(error.message);
      return { status: String(error.status), message: error.message };
    });
};

export const putListingAdapter = (formData: FormData, listingId: string): Promise<ResponseStatusModel> => {
  return axiosInstance
    .put(`${LISTINGS_URL}/${listingId}`, formData)
    .then((response: AxiosResponse<ResponseStatusModel>): ResponseStatusModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    })
    .catch((error: AxiosError): ResponseStatusModel => {
      SnackbarUtil.error(error.message);
      return { status: String(error.status), message: error.message };
    });
};
